import { render, staticRenderFns } from "./MyDashboard.vue?vue&type=template&id=32f1db26&scoped=true"
import script from "./MyDashboard.vue?vue&type=script&lang=js"
export * from "./MyDashboard.vue?vue&type=script&lang=js"
import style0 from "./MyDashboard.vue?vue&type=style&index=0&id=32f1db26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f1db26",
  null
  
)

export default component.exports